export default __webpack_public_path__ + "static/media/IMG_1557425409568.9b984eb6.jpg";